import '../../app/Blocks/TextAndMediaBlock/src/scripts/text-and-media-block.js';
import '../../app/Blocks/TextAndMediaBlock/src/scripts/editor.js';
import '../../app/Blocks/TestimonialsBlock/src/scripts/testimonials-block.js';
import '../../app/Blocks/TestimonialsBlock/src/scripts/editor.js';
import '../../app/Blocks/TeamBlock/src/scripts/team-block.js';
import '../../app/Blocks/TeamBlock/src/scripts/editor.js';
import '../../app/Blocks/SingleBlogHeaderBlock/src/scripts/single-blog-header-block.js';
import '../../app/Blocks/SingleBlogHeaderBlock/src/scripts/editor.js';
import '../../app/Blocks/SingleBlogBlock/src/scripts/single-blog-block.js';
import '../../app/Blocks/SingleBlogBlock/src/scripts/editor.js';
import '../../app/Blocks/ReportsBlock/src/scripts/reports-block.js';
import '../../app/Blocks/ReportsBlock/src/scripts/editor.js';
import '../../app/Blocks/ProcessStepsBlock/src/scripts/process-steps-block.js';
import '../../app/Blocks/ProcessStepsBlock/src/scripts/editor.js';
import '../../app/Blocks/PageHeaderBlock/src/scripts/page-header-block.js';
import '../../app/Blocks/PageHeaderBlock/src/scripts/editor.js';
import '../../app/Blocks/MediaListBlock/src/scripts/media-list-block.js';
import '../../app/Blocks/MediaListBlock/src/scripts/editor.js';
import '../../app/Blocks/HeroBlock/src/scripts/hero-block.js';
import '../../app/Blocks/HeroBlock/src/scripts/editor.js';
import '../../app/Blocks/HeaderBlock/src/scripts/header-block.js';
import '../../app/Blocks/FooterBlock/src/scripts/footer-block.js';
import '../../app/Blocks/FeaturedVideoBlock/src/scripts/featured-video-block.js';
import '../../app/Blocks/FeaturedVideoBlock/src/scripts/editor.js';
import '../../app/Blocks/FaqsBlock/src/scripts/faqs-block.js';
import '../../app/Blocks/ContactBlock/src/scripts/contact-block.js';
import '../../app/Blocks/BlogSectionBlock/src/scripts/editor.js';
import '../../app/Blocks/BlogSectionBlock/src/scripts/blog-section-block.js';
import '../../app/Blocks/BlogListBlock/src/scripts/editor.js';
import '../../app/Blocks/BlogListBlock/src/scripts/blog-list-block.js';
import '../../app/Blocks/AccordionAndMediaBlock/src/scripts/editor.js';
import '../../app/Blocks/AccordionAndMediaBlock/src/scripts/accordion-and-media-block.js';
